exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * @since 2017-05-16 20:10:45\n * @author vivaxy\n */\n.flex-center {\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-justify-content: center;\n  -moz-justify-content: center;\n  -ms-justify-content: center;\n  -o-justify-content: center;\n  justify-content: center;\n  align-items: center;\n  -webkit-align-items: center;\n  -moz-align-items: center;\n  -ms-align-items: center;\n  -o-align-items: center;\n  height: 100vh;\n}\n.loading-eat {\n  background: url(//www.dpfile.com/app/app-m-module/static/6261145dd7c0f26bc0a26831e5cb358a.gif) no-repeat transparent;\n  background-size: 90px;\n  height: 90px;\n  width: 90px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./~/@dp/cmp-prototype-lib/components/common/LoadingScreenComponent.less
// module id = 531
// module chunks = 0